// extracted by mini-css-extract-plugin
export default {"sectionTitle":"section_title_sectionTitle__1mDi3"};